import { render, staticRenderFns } from "./fullcalendars.vue?vue&type=template&id=875aaf34&scoped=true"
import script from "./fullcalendars.vue?vue&type=script&lang=js"
export * from "./fullcalendars.vue?vue&type=script&lang=js"
import style0 from "./fullcalendars.vue?vue&type=style&index=0&id=875aaf34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875aaf34",
  null
  
)

export default component.exports